/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WeightReportLineDto } from './weightReportLineDto';

export interface WeightReportSchemaDto {
  id?: string;
  workOrderId?: string;
  projectId?: string;
  status?: WeightReportSchemaDto.StatusEnum;
  recipientEmail?: string;
  createdBy?: string;
  createdAt?: string;
  sentAt?: string;
  lines?: Array<WeightReportLineDto>;
}
export namespace WeightReportSchemaDto {
  export const StatusEnum = {
    Open: 'OPEN',
    Sent: 'SENT',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
